import { render, staticRenderFns } from "./ot-tag.vue?vue&type=template&id=84ebca26&scoped=true&"
import script from "./ot-tag.vue?vue&type=script&lang=ts&"
export * from "./ot-tag.vue?vue&type=script&lang=ts&"
import style0 from "./ot-tag.vue?vue&type=style&index=0&id=84ebca26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ebca26",
  null
  
)

export default component.exports